"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTransactionRid = calculateTransactionRid;
const errors_1 = require("../blockchainClient/errors");
const gtx_1 = require("../gtx/gtx");
/**
 * Calculates and returns the transaction RID, i.e., the merkle root hash of the transaction.
 * @param transaction The transaction in format of RawGtxBody
 *
 */
function calculateTransactionRid(transaction, merkleHashVersion) {
    try {
        return (0, gtx_1.getDigestToSignFromRawGtxBody)(transaction, merkleHashVersion);
    }
    catch (error) {
        throw new errors_1.GetTransactionRidException(error);
    }
}
//# sourceMappingURL=calculateTransactionRid.js.map